import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@material-ui/core';
import { IValueAddedTaxFormValues } from '../../../../@types/model/masterData/valueAddedTax/valueAddedTaxFormValues';
import ValueAddedTaxModelHelper from '../../../../@types/model/masterData/valueAddedTax/valueAddedTaxModelHelper';
import CustomControlledTextField from '../../../customComponentV2/input/CustomControlledTextField';
import CustomLabelledCheckBox from '../../../customComponentV2/input/CustomCheckBox';
import FormDateInput from '../../../customComponentV2/button/ControlledDateInput';
import ControlledDateInput from '../../../customComponentV2/button/ControlledDateInput';

interface IValueAddedTaxEditFormProps {
    initialValues : IValueAddedTaxFormValues;
    onSubmit : (values : IValueAddedTaxFormValues) => void;
    onCancel : () => void;
}

const ValueAddedTaxEditForm = (props : IValueAddedTaxEditFormProps) : React.ReactElement => {
    const schema = ValueAddedTaxModelHelper.formSchema();

    const { handleSubmit, control, formState: { isValid, isDirty } } = useForm<IValueAddedTaxFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const onDateChange = (date : moment.Moment | null) => {
        if (!date) return null;
        props.initialValues.startDate = date;
    };

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 jcc aic mb20'}>
                        <div className={'wfill mb15'}>
                            <CustomControlledTextField 
                                className={'wfill'}
                                label={'Value %'}
                                name={'value'}
                                control={control}
                            />
                        </div>
                        <div className={'wfill mb15'}>
                            <ControlledDateInput 
                                className={'wfill'}
                                label={'Start date'}
                                name={'startDate'}
                                onDateChange={onDateChange}
                                control={control}
                            />
                        </div>
                    </div>
                    <div className='flx1 fdr jcfs'>
                        <CustomLabelledCheckBox 
                            name={'isActive'}
                            label={'Is Active'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <div className={'jcfe'}>
                            <Button className='m10' disabled={!isValid || !isDirty} type='submit' variant='contained' color='primary'>
                                OK
                            </Button>
                            <Button className='m10' variant='outlined' onClick={props.onCancel} color='primary' autoFocus>
                                CANCEL
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default ValueAddedTaxEditForm;